import CustomersEntity from '../customers/customer'
import { Entities } from '../entities'
import FilesEntity from '../files/files'

const colorsMap = {
	Blanco: '#FFFFFF',
	Negro: '#000000',
	Gris: '#808080',
	Amarillo: '#FFFF00',
	Verde: '#008000',
	Azul: '#0000FF',
	Rojo: '#FF0000',
	Naranja: '#FFA500',
	Morado: '#800080',
	Rosa: '#FFC0CB',
	Beige: '#F5F5DC',
	Crema: '#FFFDD0',
	Celeste: '#87CEEB',
	'Verde Menta': '#98FF98',
	Lila: '#C8A2C8',
	Lavanda: '#E6E6FA',
	Coral: '#FF7F50',
	Salmón: '#FA8072',
	'Azul Marino': '#000080',
	'Verde Oliva': '#808000',
	Vino: '#800000',
	Marrón: '#A52A2A',
	Chocolate: '#D2691E',
	Granate: '#8B0000',
	'Gris Oscuro': '#A9A9A9',
	Dorado: '#FFD700',
	Plateado: '#C0C0C0',
	Bronce: '#CD7F32',
	Cobre: '#B87333',
	Fucsia: '#FF00FF',
	Turquesa: '#40E0D0',
	Esmeralda: '#50C878',
	Limón: '#CCFF00',
	Magenta: '#FF00FF',
	Neón: '#39FF14',
	Terracota: '#E2725B',
	Mostaza: '#FFDB58',
	'Azul Cielo': '#87CEEB',
	'Verde Bosque': '#228B22',
	'Rosa Pastel': '#FFD1DC',
	'Gris Perla': '#D3D3D3',
	'Azul Petróleo': '#013220',
	'Marrón Caramelo': '#AF6E4D',
	'Verde Manzana': '#8DB600',
	'Azul Zafiro': '#0F52BA',
	'Amarillo Girasol': '#FFDA03',
	'Naranja Mandarina': '#FF8800',
	'Marrón Madera': '#DEB887',
	'Rojo Cereza': '#DE3163',
	'Verde Jade': '#00A86B',
} as const

const flavorMap = {
	Naranja: 'Naranja',
	Vainilla: 'Vainilla',
	Chocolate: 'Chocolate',
	Fresa: 'Fresa',
	Helado: 'Helado',
	'Cookies and Cream': 'Cookies and Cream',
	Sandía: 'Sandía',
	'Manzana Verde': 'Manzana Verde',
	'Sin Sabor': 'Sin Sabor',
	Ponche: 'Ponche',
	'Frutos Rojos': 'Frutos Rojos',
	'Frutos Amarillos': 'Frutos Amarillos',
	'Frutos Azules': 'Frutos Azules',
	'Frutos Morados': 'Frutos Morados',
	Coco: 'Coco',
	Mango: 'Mango',
	Plátano: 'Plátano',
	'Piña Colada': 'Piña Colada',
	Café: 'Café',
	Caramelo: 'Caramelo',
	Menta: 'Menta',
	'Té Verde': 'Té Verde',
	Limón: 'Limón',
	Mora: 'Mora',
	Maracuyá: 'Maracuyá',
	Uva: 'Uva',
	Durazno: 'Durazno',
	Chicle: 'Chicle',
	Almendra: 'Almendra',
	Avellana: 'Avellana',
	Guayaba: 'Guayaba',
	Feijoa: 'Feijoa',
	Lulo: 'Lulo',
	Tamarindo: 'Tamarindo',
	Borojo: 'Borojó',
	Guanábana: 'Guanábana',
	Mangostino: 'Mangostino',
	Arazá: 'Arazá',
	Chontaduro: 'Chontaduro',
	Corozo: 'Corozo',
	Arándano: 'Arándano',
	Frambuesa: 'Frambuesa',
	Moras_Azules: 'Moras Azules',
	'Berry Mix': 'Berry Mix',
	Cranberry: 'Cranberry',
	'Blueberry Cheesecake': 'Blueberry Cheesecake',
	Arequipe: 'Arequipe',
	'Panela y Limón': 'Panela y Limón',
	'Vainilla Caramelo': 'Vainilla Caramelo',
	'Chocolate Blanco': 'Chocolate Blanco',
	Brownie: 'Brownie',
	Banano: 'Banano',
	'Vainilla Banano': 'Vainilla Banano',
	"Gulupa Ice": "Gulupa Ice",
	"Red Fusion": "Red Fusion",
	"Watermelon Candy": "Watermelon Candy",
	"Té chai": "Té chai",
	"Helado de Fresa": 'Helado de Fresa',
	"Canela": 'Canela',
	'Birthday Cake': 'Birthday Cake',
	'Funfetti': 'Funfetti',
	'Cake Batter': 'Cake Batter',
	'Vanilla Milkshake': 'Vanilla Milkshake',
	'Chocolate Milkshake': 'Chocolate Milkshake',
	'Strawberry Milkshake': 'Strawberry Milkshake',
	'Oreo': 'Oreo',
	'Double Chocolate': 'Double Chocolate',
	'Mint Chocolate': 'Mint Chocolate',
	'Chocolate Peanut Butter': 'Chocolate Peanut Butter',
	'White Chocolate': 'White Chocolate',
	'Mocha': 'Mocha',
	'Cappuccino': 'Cappuccino',
	'Espresso': 'Espresso',
	'Latte': 'Latte',
	'French Vanilla': 'French Vanilla',
	'Vanilla Ice Cream': 'Vanilla Ice Cream',
	'Neapolitan': 'Neapolitan',
	'Rocky Road': 'Rocky Road',
	'Mint Chip': 'Mint Chip',
	'Strawberry Cheesecake': 'Strawberry Cheesecake',
	'Chocolate Cheesecake': 'Chocolate Cheesecake',
	'Vanilla Cheesecake': 'Vanilla Cheesecake',
	'New York Cheesecake': 'New York Cheesecake',
	'Tiramisú': 'Tiramisú',
	'Red Velvet': 'Red Velvet',
	'Cinnamon Roll': 'Cinnamon Roll',
	'Apple Pie': 'Apple Pie',
	'Pumpkin Pie': 'Pumpkin Pie',
	'Banana Cream': 'Banana Cream',
	'Coconut Cream': 'Coconut Cream',
	'Lemon Pie': 'Lemon Pie',
	'Key Lime Pie': 'Key Lime Pie',
	'Dragon Fruit': 'Dragon Fruit',
	'Lychee': 'Lychee',
	'Passion Fruit': 'Passion Fruit',
	'Acai': 'Acai',
	'Pomegranate': 'Pomegranate',
	'Blood Orange': 'Blood Orange',
	'Pink Grapefruit': 'Pink Grapefruit',
	'Kiwi': 'Kiwi',
	'Papaya': 'Papaya',
	'Starfruit': 'Starfruit',
	'Jackfruit': 'Jackfruit',
	'Rambutan': 'Rambutan',
	'Mangosteen': 'Mangosteen',
	'Tropical Punch': 'Tropical Punch',
	'Bahama Mama': 'Bahama Mama',
	'Hurricane': 'Hurricane',
	'Mai Tai': 'Mai Tai',
	'Blue Hawaii': 'Blue Hawaii',
	'Pineapple Mango': 'Pineapple Mango',
	'Coconut Pineapple': 'Coconut Pineapple',
	'Banana Coconut': 'Banana Coconut',
	'Mango Passion': 'Mango Passion',
	'Cotton Candy': 'Cotton Candy',
	'Bubble Gum': 'Bubble Gum',
	'Jolly Rancher': 'Jolly Rancher',
	'Skittles': 'Skittles',
	'Starburst': 'Starburst',
	'Sour Apple': 'Sour Apple',
	'Sour Cherry': 'Sour Cherry',
	'Blue Raspberry': 'Blue Raspberry',
	'Grape Soda': 'Grape Soda',
	'Orange Cream': 'Orange Cream',
	'Root Beer Float': 'Root Beer Float',
	'Cherry Cola': 'Cherry Cola',
	'Lemon Lime': 'Lemon Lime',
	'Fruit Punch': 'Fruit Punch',
	'Salted Caramel': 'Salted Caramel',
	'Caramel Macchiato': 'Caramel Macchiato',
	'Dulce de Leche': 'Dulce de Leche',
	'Maple Syrup': 'Maple Syrup',
	'Honey': 'Honey',
	'Peanut Butter': 'Peanut Butter',
	'Almond Butter': 'Almond Butter',
	'Cashew': 'Cashew',
	'Pistachio': 'Pistachio',
	'Macadamia': 'Macadamia',
	'Pecan': 'Pecan',
	'Walnut': 'Walnut',
	'Chai Latte': 'Chai Latte',
	'Pumpkin Spice': 'Pumpkin Spice',
	'Gingerbread': 'Gingerbread',
	'Eggnog': 'Eggnog',
	'Cardamom': 'Cardamom',
	'Clove': 'Clove',
	'Nutmeg': 'Nutmeg',
	'Allspice': 'Allspice',
	'Mora Castilla': 'Mora Castilla',
	'Uchuva': 'Uchuva',
	'Pitahaya': 'Pitahaya',
	'Zapote': 'Zapote',
	'Mamey': 'Mamey',
	'Curuba': 'Curuba',
	'Granadilla': 'Granadilla',
	'Tomate de Árbol': 'Tomate de Árbol',
	'Badea': 'Badea',
	'Níspero': 'Níspero',
	'Chirimoya': 'Chirimoya',
	'Anón': 'Anón',
	'Pomarrosa': 'Pomarrosa',
	'Carambolo': 'Carambolo',
	'Mojito': 'Mojito',
	'Caipirinha': 'Caipirinha',
	'Margarita': 'Margarita',
	'Sex on the Beach': 'Sex on the Beach',
	'Cosmopolitan': 'Cosmopolitan',
	'Blue Lagoon': 'Blue Lagoon',
	'Tequila Sunrise': 'Tequila Sunrise',
	'Long Island': 'Long Island',
	'Sangria': 'Sangria',
	'Fruity Pebbles': 'Fruity Pebbles',
	'Cocoa Puffs': 'Cocoa Puffs',
	'Lucky Charms': 'Lucky Charms',
	'Froot Loops': 'Froot Loops',
	'Cinnamon Toast Crunch': 'Cinnamon Toast Crunch',
	'Captain Crunch': 'Captain Crunch',
	'Honeycomb': 'Honeycomb',
	'Cornflakes': 'Cornflakes',
	'Lavender': 'Lavender',
	'Rose': 'Rose',
	'Hibiscus': 'Hibiscus',
	'Earl Grey': 'Earl Grey',
	'Matcha': 'Matcha',
	'Jasmine': 'Jasmine',
	'Elderflower': 'Elderflower',
	'Cucumber Mint': 'Cucumber Mint',
	'Basil': 'Basil',
	'Rosemary': 'Rosemary',
	'Thyme': 'Thyme',
	'Energy Drink': 'Energy Drink',
	'Monster': 'Monster',
	'Red Bull': 'Red Bull',
	'Rockstar': 'Rockstar',
	'NOS': 'NOS',
	'Bang': 'Bang',
	'Reign': 'Reign',
	'Christmas Cookie': 'Christmas Cookie',
	'Peppermint Bark': 'Peppermint Bark',
	'Hot Chocolate': 'Hot Chocolate',
	'Marshmallow': 'Marshmallow',
	'Graham Cracker': 'Graham Cracker',
	'S\'mores': 'S\'mores',
	'Mochi': 'Mochi',
	'Taro': 'Taro',
	'Ube': 'Ube',
	'Lemon Curd': 'Lemon Curd',
	'Elderberry': 'Elderberry',
	'Gooseberry': 'Gooseberry',
	'Blackcurrant': 'Blackcurrant',
	'Rhubarb': 'Rhubarb',
	'Chocolate Mint Chip': 'Chocolate Mint Chip',
	'Strawberry Banana': 'Strawberry Banana',
	'Apple Cinnamon': 'Apple Cinnamon',
	'Orange Vanilla': 'Orange Vanilla',
	'Lemon Vanilla': 'Lemon Vanilla',
	'Cherry Vanilla': 'Cherry Vanilla',
	'Peach Mango': 'Peach Mango',
	'Berry Banana': 'Berry Banana',
	'Tropical Mango': 'Tropical Mango',
	'Wild Berry': 'Wild Berry',
	'Mixed Berry': 'Mixed Berry',
	'Forest Berry': 'Forest Berry',
	'Summer Berry': 'Summer Berry',
	'Winter Berry': 'Winter Berry',
	'Icy Blue Razz': 'Icy Blue Razz',
	'Tigers Blood': 'Tigers Blood',
	'Bombsicle': 'Bombsicle',
	'Rocket Pop': 'Rocket Pop',
	'Miami Vice': 'Miami Vice',
	'Patty\'s Iced Tea': 'Patty\'s Iced Tea',
	'White Gummy Bear': 'White Gummy Bear',
	'Orange Ice Dream': 'Orange Ice Dream',
	'Mango Peach': 'Mango Peach',
	'Blackberry Lemonade': 'Blackberry Lemonade',
	'Berry Burst': 'Berry Burst',
	'Citrus Rain': 'Citrus Rain',
	'Tropic Wave': 'Tropic Wave',
	'Lucky Lemon': 'Lucky Lemon',
	'Sour Watermelon Candy': 'Sour Watermelon Candy',
	'Wild Grape': 'Wild Grape',
	'Lychee Bomb': 'Lychee Bomb',
	'Strawberry Candy': 'Strawberry Candy',
	'Orange Rush': 'Orange Rush',
	'Black Cherry Vanilla': 'Black Cherry Vanilla',
	'Exotic Kiwi': 'Exotic Kiwi',
	'White Frost': 'White Frost',
	'Gym N Juice': 'Gym N Juice',
	'Blood Raz': 'Blood Raz',
	'Killa OJ': 'Killa OJ',
	'Green Apple Jolly Rancher': 'Green Apple Jolly Rancher',
	'Sour Peach Rings': 'Sour Peach Rings',
	'Arctic White': 'Arctic White',
	'Osaka Cherry Blossom': 'Osaka Cherry Blossom',
	'Baba Yaga Blue Raz': 'Baba Yaga Blue Raz',
	'Coffee Ice Cream': 'Coffee Ice Cream',
	'Slow Churn Vanilla': 'Slow Churn Vanilla',
	'Cookies N Cream Ice Cream': 'Cookies N Cream Ice Cream',
	'Mint Chocolate Chip Ice Cream': 'Mint Chocolate Chip Ice Cream',
	'Strawberry Ice Cream': 'Strawberry Ice Cream',
	'Pistachio Ice Cream': 'Pistachio Ice Cream',
	'Butter Pecan Ice Cream': 'Butter Pecan Ice Cream',
	'Italian Ice Cream': 'Italian Ice Cream',
	'Rainbow Sherbet': 'Rainbow Sherbet',
	'Orange Creamsicle': 'Orange Creamsicle',
	'Banana Split': 'Banana Split',
	'Caramel Swirl': 'Caramel Swirl',
	'Fudge Brownie': 'Fudge Brownie',
	'Key Lime Sherbet': 'Key Lime Sherbet',
	'Coconut Ice Cream': 'Coconut Ice Cream',
	'Camu Camu': 'Camu Camu',
	'Copoazú': 'Copoazú',
	'Canangucha': 'Canangucha',
	'Cocona': 'Cocona',
	'Maraco': 'Maraco',
	'Piña Amazónica': 'Piña Amazónica',
	'Lulo Amazónico': 'Lulo Amazónico',
	'Anón Amazónico': 'Anón Amazónico',
	'Papayuela': 'Papayuela',
	'Melón Colombiano': 'Melón Colombiano',
	'Tamarillo': 'Tamarillo',
	'Chontaduro Dulce': 'Chontaduro Dulce',
	'Madroño': 'Madroño',
	'Pepino Dulce': 'Pepino Dulce',
	'Gulupa Morada': 'Gulupa Morada',
	'Pitaya Rosa': 'Pitaya Rosa',
	'Aguacate Hass': 'Aguacate Hass',
	'Café Colombiano': 'Café Colombiano',
	'Panela': 'Panela',
	'Aguapanela': 'Aguapanela',
	'Bocadillo Veleño': 'Bocadillo Veleño',
	'Cocada': 'Cocada',
	'Arroz con Leche': 'Arroz con Leche',
	'Natilla': 'Natilla',
	'Brevas con Arequipe': 'Brevas con Arequipe',
	'Roscón': 'Roscón',
	'Alfajor': 'Alfajor',
	'Mazamorra': 'Mazamorra',
	'Chicha': 'Chicha',
	'Avena': 'Avena',
	'Quinua': 'Quinua',
	'Chía': 'Chía',
	'Amaranto': 'Amaranto',
	'Blue Ice': 'Blue Ice',
	'Red Ice': 'Red Ice',
	'Purple Ice': 'Purple Ice',
	'Green Ice': 'Green Ice',
	'Yellow Ice': 'Yellow Ice',
	'Electric Lemon': 'Electric Lemon',
	'Neon Lime': 'Neon Lime',
	'Atomic Orange': 'Atomic Orange',
	'Lightning Berry': 'Lightning Berry',
	'Thunder Grape': 'Thunder Grape',
	'Voltage Cherry': 'Voltage Cherry',
	'Shock Wave': 'Shock Wave',
	'Power Surge': 'Power Surge',
	'Energy Blast': 'Energy Blast',
	'Turbo Punch': 'Turbo Punch',
	'Nitro Cola': 'Nitro Cola',
	'High Voltage': 'High Voltage',
	'Electric Storm': 'Electric Storm',
	'Laser Lime': 'Laser Lime',
	'Cyber Grape': 'Cyber Grape',
	'Matrix Green': 'Matrix Green',
	'Neon Blue': 'Neon Blue',
	'Electric Pink': 'Electric Pink',
	'Plasma Purple': 'Plasma Purple',
	'Ion Orange': 'Ion Orange',
	'Fusion Berry': 'Fusion Berry',
	'X-treme Citrus': 'X-treme Citrus',
	'Ultra Violet': 'Ultra Violet',
	'Mega Mix': 'Mega Mix',
	'Hyper Melon': 'Hyper Melon',
	'Super Sour': 'Super Sour',
	'Extreme Energy': 'Extreme Energy',
	'Maximum Power': 'Maximum Power',
	'Ultimate Rush': 'Ultimate Rush',
	'Infinity Punch': 'Infinity Punch',
	'Especial': 'Especial',
	'Frutos Tropicales' : 'Frutos Tropicales' 
} as const

export default flavorMap

const modalitiesMap = {
	Virtual: 'Todo el país y el mundo.',
	Presencial: 'Solo en el municipio de Chinchiná, Caldas, Colombia.',
	Híbrida: 'Combinación de sesiones virtuales y presenciales.',
	A_Domicilio: 'Disponible en áreas específicas del departamento.',
	SemiPresencial: 'Clases presenciales algunos días y virtuales otros.',
	Grabada: 'Contenido pregrabado disponible en cualquier momento.',
	En_Vivo: 'Sesiones virtuales en tiempo real con interacción.',
	Itinerante: 'Presencial en diferentes municipios o zonas del país.',
} as const

const objectivesMap = {
	'Pérdida de grasa': 'Reducir grasa corporal.',
	'Ganancia de masa muscular': 'Aumentar músculo.',
	Mantenimiento: 'Mantener condición física.',
	'Mejora del rendimiento': 'Optimizar fuerza y resistencia.',
	Recuperación: 'Acelerar recuperación física.',
	'Salud general': 'Mejorar bienestar integral.',
	'Definición muscular': 'Resaltar masa muscular.',
	'Acondicionamiento físico': 'Mejorar forma física general.',
	'Aumento de energía': 'Incrementar vitalidad diaria.',
	'Preparación deportiva': 'Listo para una competencia.',
	'Movilidad y flexibilidad': 'Mejorar rango de movimiento.',
	'Resistencia cardiovascular': 'Aumentar capacidad aeróbica.',
	'Control de peso': 'Mantener peso saludable.',
	Rehabilitación: 'Recuperarse de lesiones.',
	'Bienestar mental': 'Reducir estrés y mejorar ánimo.',
	'Fuerza explosiva': 'Incrementar potencia muscular.',
	'Resistencia muscular': 'Aumentar duración del esfuerzo.',
	'Postura y alineación': 'Corregir y prevenir dolencias.',
	'Entrenamiento funcional': 'Mejorar movimientos cotidianos.',
	'Preparación para pruebas físicas': 'Rendir al máximo en evaluaciones.',
	'Recuperación postparto': 'Volver a la forma física segura.',
	'Prevención de lesiones': 'Reducir riesgos durante el ejercicio.',
	'Adaptación para principiantes': 'Introducirse al entrenamiento.',
	'Entrenamiento para tercera edad': 'Mantener movilidad y fuerza.',
	'Mejora de agilidad': 'Optimizar velocidad de reacción.',
	'Entrenamiento de equilibrio': 'Aumentar estabilidad corporal.',
	'Primeros pasos en el fitness': 'Iniciar actividad física de forma segura.',
	'Aprender técnica básica': 'Dominar ejercicios fundamentales.',
	'Rutina fácil en casa': 'Entrenar sin necesidad de gimnasio.',
	'Incremento progresivo': 'Aumentar carga de forma gradual.',
	'Pérdida de peso suave': 'Reducir peso sin presión.',
	'Mejora de coordinación': 'Sincronizar movimientos y control.',
	'Entrenamiento de bajo impacto': 'Ejercitar sin sobrecargar articulaciones.',
	'Introducción al cardio': 'Mejorar salud cardiovascular.',
	'Hábitos saludables iniciales': 'Adoptar rutinas de bienestar.',
	'Confianza en el entrenamiento': 'Sentirse seguro al ejercitarse.',
	'Recuperación muscular avanzada': 'Terapias y rutinas post-entrenamiento.',
	'Fortalecimiento articular': 'Proteger y mejorar articulaciones.',
	'Rehabilitación deportiva': 'Recuperarse de lesiones deportivas.',
	'Prevención de recaídas': 'Evitar nuevas lesiones.',
	'Plan antiinflamatorio': 'Reducir inflamación mediante alimentación.',
	'Alimentación para alto rendimiento': 'Nutrición para atletas.',
	'Suplemetación personalizada': 'Optimizar rendimiento con suplementos.',
	'Control hormonal deportivo': 'Equilibrar hormonas para el entrenamiento.',
	'Optimización metabólica': 'Mejorar quema de energía y eficiencia.',
	'Farmacología deportiva segura': 'Uso controlado de ayudas ergogénicas.',
	'Recuperación postcompetencia': 'Restaurar energía tras eventos.',
	'Entrenamiento de fuerza máxima': 'Superar límites de potencia.',
	'Entrenamiento HIIT especializado': 'Cardio intenso para alto nivel.',
	'Plan de resistencia extrema': 'Prepararse para desafíos prolongados.',
	'Mejora de la composición corporal': 'Optimizar músculo y grasa.',
	'Dieta cetogénica': 'Plan bajo en carbohidratos.',
	'Dieta alta en proteínas': 'Enfoque proteico para músculo.',
	'Plan vegano deportivo': 'Nutrición sin origen animal.',
	'Plan para ganancia limpia': 'Aumentar músculo sin exceso de grasa.',
	'Recuperación neuromuscular': 'Mejorar conexión mente-músculo.',
} as const

const sizeMap = {
	S: '84-88 cm',
	M: '92-96 cm',
	L: '100-104 cm',
	X: '108-112 cm',
	XL: '116-120 cm',
	XXL: '124-128 cm',
	XXXL: '132-136 cm',

	XS: '80-84 cm',
	XXS: '76-80 cm',
	XXXXL: '140-144 cm',

	'4': '84-86 cm',
	'6': '88-90 cm',
	'8': '92-94 cm',
	'10': '96-98 cm',
	'12': '100-102 cm',
	'14': '104-106 cm',
	'16': '108-110 cm',
	'18': '112-114 cm',

	'35': '22.5 cm',
	'36': '23 cm',
	'37': '23.5 cm',
	'38': '24 cm',
	'39': '24.5 cm',
	'40': '25 cm',
	'41': '25.5 cm',
	'42': '26 cm',
	'43': '26.5 cm',
	'44': '27 cm',
	'45': '27.5 cm',
	'46': '28 cm',
} as const

interface ProductEntity {
	_id?: string
	type: Entities
	category: ProductCategoryEntity
	shipping_info: ShippingInfo
	images?: FilesEntity[]
	name: string
	description: string
	discount: number
	brand: string
	active: boolean
	raitings?: RaitingsEntity[]
	attributes: AttributeProductEntity[]
	details: ProductDetails
	_created?: Date
	_modified?: Date
	_deleted?: boolean
}

interface ShippingInfo {
	isHaveShipping: boolean
	type: Paymethods
	price: number
}

enum Paymethods {
	pay = 'pay',
	free = 'free',
}

interface ProductCategoryEntity {
	_id: string
	name: string
}

interface GeneralDetailsSupplements {
	brand: string
	principal_supplement: string
	type: string
}

interface SpecificationsSupplements {
	is_gluten_free: boolean
	is_vegan: boolean
	have_lactose: boolean
}

interface BuyFormat {
	suplement_format: string
	container_type: string
}

interface NutritionalInformation {
	ingredients: string
	nutritional_portion_value: string
	portion_weight: string
}

interface GeneralDetailsClothes {
	brand: string
	model: string
	age: string
	gender: string
	materials: string
}

interface GeneralDetailsPlansPersonalized {
	nutrition_plan: boolean
	training_plan: boolean
	duration: string
	modality: string
	place: string
}

interface GeneralDetailsAccessories {
	brand: string
	model: string
	age: string
	gender: string
	materials: string
}

interface SpecificationsAccessories {
	is_non_slip: boolean
	is_adjustable: boolean
}

interface ProductDetails {
	general_details:
	| GeneralDetailsSupplements
	| GeneralDetailsClothes
	| GeneralDetailsPlansPersonalized
	| GeneralDetailsAccessories
	specifications?: SpecificationsSupplements | SpecificationsAccessories
	buy_format?: BuyFormat
	nutritional_information?: NutritionalInformation
}

interface SupplementsDetails {
	general_details: GeneralDetailsSupplements
	specifications: SpecificationsSupplements
	buy_format: BuyFormat
	nutritional_information: NutritionalInformation
}

interface ClothesDetails {
	general_details: GeneralDetailsClothes
}

interface PlansPersonalizedDetails {
	general_details: GeneralDetailsPlansPersonalized
}

interface AccessoriesDetails {
	general_details: GeneralDetailsAccessories
	specifications: SpecificationsAccessories
}

interface RaitingsEntity {
	_id?: string
	customer: Partial<CustomersEntity>
	rate: number
	comment: string
	_created?: Date
	_modified?: Date
	_deleted?: boolean
}

type ValueType =
	| keyof typeof colorsMap
	| keyof typeof sizeMap
	| keyof typeof flavorMap
	| keyof typeof objectivesMap
	| keyof typeof modalitiesMap

type ReferenceType =
	| (typeof colorsMap)[keyof typeof colorsMap]
	| (typeof sizeMap)[keyof typeof sizeMap]
	| (typeof flavorMap)[keyof typeof flavorMap]
	| (typeof objectivesMap)[keyof typeof objectivesMap]
	| (typeof modalitiesMap)[keyof typeof modalitiesMap]

const attributeMaps = {
	...colorsMap,
	...sizeMap,
	...flavorMap,
	...objectivesMap,
	...modalitiesMap,
} as const

interface AttributeProductEntity {
	_id?: string
	name: NameAttributes[]
	type: Entities
	value: ValueType[]
	reference: ReferenceType[]
	price: number
	quantity: number
	image?: FilesEntity
	_created?: Date
	_modified?: Date
	_deleted?: boolean
}

enum NameAttributes {
	COLOR = 'color',
	SIZE = 'size',
	FLAVOR = 'flavor',
	MODALITY = 'modality',
	OBJECTIVE = 'objective',
}

export {
	attributeMaps,
	colorsMap,
	sizeMap,
	flavorMap,
	objectivesMap,
	modalitiesMap,
	Paymethods,
	NameAttributes,
}
export type {
	ValueType,
	ReferenceType,
	ProductEntity,
	ProductCategoryEntity,
	ShippingInfo,
	ProductDetails,
	SupplementsDetails,
	ClothesDetails,
	PlansPersonalizedDetails,
	AccessoriesDetails,
	AttributeProductEntity,
	RaitingsEntity,
}
